import { Component, Inject, OnInit } from '@angular/core';
import { MD_DIALOG_DATA } from '@angular/material';
import { Benefit } from 'app/model/products/product-room-detail.model';

@Component({
  selector: 'act-dialog-room-note',
  templateUrl: './dialog-room-note.component.html',
  styleUrls: ['./dialog-room-note.component.scss']
})
export class DialogRoomNoteComponent implements OnInit {

  constructor(
    @Inject(MD_DIALOG_DATA) public data: Benefit[] = []
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-room-note/dialog-room-note.component.ts